import { Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import { setNeoAuthenticated } from "../../redux/actions/UserActions";
import { appConfig } from "App";

export const NeoProtectedRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const neoAuthenticated = useSelector((state) => state.user.neoAuthenticated);
  const [checking, setChecking] = useState(!neoAuthenticated);

  const location = useLocation();
  const pathAndQuery = location.pathname + location.search;
  const urlParams = new URLSearchParams(location.search);
  const sessionId = urlParams.get('sessionid') || localStorage.getItem('sessionid');

  useEffect(() => {
    // If already authenticated, skip the check
    if (neoAuthenticated) {
      setChecking(false);
      return;
    }

    // Check Neo session validity
    const checkSession = async () => {
      try {
        const response = await axios.post('/neo-session-check', {
          params: {
            uid: sessionId,
          },
        });

        if (response.data === "LOGIN SUCCESSFUL" || response.status === 200) {
          // Session is valid - set authentication to true
          dispatch(setNeoAuthenticated(true));
          setChecking(false);
        } else {
          // Session invalid - redirect to login
          window.location.href = `${appConfig.CENTRAL_API}/neo-login`;
        }
      } catch (error) {
        console.error('Neo session check failed:', error);
        // Session invalid - redirect to login
        window.location.href = `${appConfig.CENTRAL_API}/neo-login`;
      }
    };

    checkSession();
  }, [neoAuthenticated, dispatch]);

  return (
    <Route
      {...rest}
      render={(props) => {
        // Show loading while checking session
        if (checking) {
          return (
            <div className="loader" style={{ padding: '20px', textAlign: 'center' }}>
              <CircularProgress />
              <p>Verifying your session...</p>
            </div>
          );
        }

        // Render component if authenticated
        if (neoAuthenticated) {
          return <Component {...props} />;
        }

        return null;
      }}
    />
  );

  ///////////////////////////////
  // useEffect(() => {
  //     // This runs exactly once when the component mounts
  //     window.location.href = '${appConfig.CENTRAL_API}/neo-login';
  //   }, []); // Empty dependency array ensures it only runs on load

  //   return (
  //     <div style={{ padding: '20px', textAlign: 'center' }}>
  //       <h3>Redirecting to NEO login...</h3>
  //       <p>If you are not redirected automatically, please wait.</p>
  //     </div>
  //   );

};
